module.exports = __webpack_public_path__ + "img/hrm-katherine-lg.da5f970.png";